import { FC } from "react";
import { Alert } from "@mui/material";
import __ from "src/utils/Translations";

const PermissionsAlert: FC = () => (
  <Alert severity="warning" sx={{ mb: "1rem" }}>
    {__("Nie posiadasz uprawnień, aby zarządzać tą stroną.")}
  </Alert>
);

export default PermissionsAlert;
